function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from 'prop-types';
import React from 'react';
import { useTheme } from 'styled-components';
import TextStyle from './styled';

const Text = ({
  children,
  color,
  ...props
}) => {
  const theme = useTheme();
  const defaultColor = theme.base.black;
  return /*#__PURE__*/React.createElement(TextStyle, _extends({
    color: color || defaultColor
  }, props), children);
};

Text.defaultProps = {
  children: null,
  color: null,
  bold: false,
  center: false
};
Text.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  bold: PropTypes.bool,
  center: PropTypes.bool
};
export default Text;